const CreditNoteReportReducer = (state, action) => {
  switch (action.type) {
    case "PROCESS_START":
      return {
        ...state,
        loading: true,
        creditNotes: [],
        totalAmount: 0,
        totalVAT: 0,
        totalCredit: 0,
        count: 0,
        error: null,
      };

    case "FETCH_CREDIT_NOTE_RECORDS":
      return {
        ...state,
        loading: false,
        creditNotes: action.payload.data || [],
        totalAmount: action.payload.totalAmount || 0,
        totalVAT: action.payload.totalVAT || 0,
        totalCredit: action.payload.totalCredit || 0,
        count: action.payload.count || 0,
        error: null,
      };

    case "PROCESS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
        creditNotes: [],
      };

    case "FETCH_CLIENT_RECORD":
      return {
        ...state,
        clients: action.payload.data,
      };

    default:
      return state;
  }
};

export default CreditNoteReportReducer;
